import type { IconProps } from '../types/IconProps.ts';
export const Menu: IconProps = {
    name: 'Menu',
    children: [
        `<path d="M4 5h15M4 12h15M4 19h15" />`,
    ]
};